import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import spbg from '../assets/spbg.webp'
import ico1 from '../assets/ico1.jpg';
import ico2 from '../assets/ico2.jpg';
import ico3 from '../assets/ico3.jpg';
import ico4 from '../assets/ico4.jpg';
import ico5 from '../assets/ico5.jpg';
import ico6 from '../assets/ico6.jpg';
import ico7 from '../assets/derma.jpg'
import ico8 from '../assets/orth.jpg'
import ScrollToTop from '../Components/Scroll.js'

const Services = () => {
  return (
    <>
      <Navbar></Navbar>
     
      <div className="relative w-full h-[300px]">
        {/* Background Image */}
        <img src={spbg} alt="About Us" className="w-full h-full object-cover" />

        {/* Centered Text */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-6xl font-bold drop-shadow-md">
           Medical Specialities
          </h1>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4">
  {/* Card 1 */}
  <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico1}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Mental Health</h2>
  </div>

  {/* Card 2 */}
  <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico2}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Podiatry</h2>
  </div>

  {/* Card 3 */}
  <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico3}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Internal Medicine</h2>
  </div>

  {/* Card 4 */}
  <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico4}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Family Practice Billing</h2>
  </div>

  {/* Card 5 */}
  <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico5}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Urgent Care</h2>
  </div>

  {/* Card 6 */}
  <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico6}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Pediatrics</h2>
  </div>
   {/* Card 7 */}
   <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico7}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Dermatology</h2>
  </div>
   {/* Card 8 */}
   <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
    <img
      src={ico8}
      alt="Icon"
      className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
    />
    <h2 className="text-lg font-bold">Opthamology</h2>
  </div>
</div>
<ScrollToTop></ScrollToTop>
      <Footer></Footer>
    </>
  );
};

export default Services;
